export const CALENDAR_LABELS = {
  TITLE: 'Booking Calendar',
  GROUND: 'Ground',
  FIELD: 'Field',
  DATE_RANGE: 'Date Range',
};

export const CALENDAR_OPTIONS = {
  ALL_GROUNDS: 'All Grounds',
  ALL_FIELDS: 'All Fields',
};

export const CALENDAR_STATUS = {
  BOOKED: 'booked',
  BOOKED_LABEL: 'Booked',
  AVAILABLE: 'Available',
};

export const CALENDAR_VIEWS = {
  MONTH: 'month',
  WEEK: 'week',
  DAY: 'day',
};

export const CALENDAR_MESSAGES = {
  LOADING: 'Loading calendar...',
  ERROR_LOAD_GROUNDS: 'Failed to load grounds',
  ERROR_LOAD_FIELDS: 'Failed to load fields',
  ERROR_LOAD_CALENDAR: 'Failed to load calendar data',
};

export const CALENDAR_TOOLTIP = {
  STATUS: 'Status:',
  USER: 'User:',
};

export const CALENDAR_EVENT_TITLES = {
  AVAILABLE_SUFFIX: ' - Available',
  BOOKED_SUFFIX: ' - Booked',
};

export const CALENDAR_MODAL = {
  TITLE: 'Select Sport',
  DESCRIPTION: 'Please select a sport for this field to continue with booking',
  CONTINUE: 'Continue',
  CANCEL: 'Cancel',
  LOADING_SPORTS: 'Loading sports...',
  ERROR_LOAD_FIELD: 'Failed to load field details',
  NO_SPORTS: 'No sports available for this field',
};

